import actions from './_actions'
import mutations from './_mutations'

import about from './about'
import contact from './contact'
import citizenships from './citizenships'
import employments from './employments'
import educations from './educations'
import memberships from './memberships'
import skills from './skills'
import socialMedia from './socials'

export default {
    namespaced: true,
    state: {
        memberId: false, // profile id from url/router
        entityId: false, // profile id from url/router
        profileState: {},
        profileSections: {
            about: 'About',
            contact: 'contact',
            citizenships: 'citizenship',
            // family: 'family',
            memberships: 'memberships',
            employments: 'employment',
            educations: 'education',
            skills: 'skills',
            socials: 'social',
        },
        profileOptions: {},
        countries: {}
    },
    getters: {
        basicInfo: state => state.profileState,
        memberId: state => state.memberId,
        entityId: state => state.entityId,
        profileSections: state => state.profileSections,
        profileOptions: state => state.profileOptions,
        countries: state => state.countries
    },
    actions,
    mutations,
    modules: {
        about,
        contact,
        citizenships,
        employments,
        memberships,
        educations,
        skills,
        socialMedia
    }
}



// WEBPACK FOOTER //
// ./src/store/profile/index.js